import { render, staticRenderFns } from "./pep.vue?vue&type=template&id=f6f1f028"
import script from "./pep.vue?vue&type=script&lang=ts"
export * from "./pep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports